import { LOAD_GOSPEL_HOME } from '@/store/protocols'
export default [
    {
        name: 'gospel/first',
        path: '/gospel/first',
        component: () => import('./Root.vue'),
        meta: {
            asyncData: LOAD_GOSPEL_HOME.join('/')
        }
    }
]
